function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.195 6.224L2.527 4.43 1 12l7.032-1.65-1.49-1.603c.075-.087.158-.18.253-.282.827-.886 2.464-2.325 4.14-2.001 1.273.246 2.389 1.474 3.315 3.65.086.2.3.296.493.22a.395.395 0 00.142-.097.443.443 0 00.1-.412c-.28-1.065-1.414-4.613-4.243-5.586-1.89-.65-4.093.03-6.547 1.985z",
  fill: "currentColor"
})));